import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "@/components/ui/dialog";

type Props = {
	title: string;
	url: string;
	alt: string;
	children: React.ReactNode;
};

export const Lightbox = ({ children, url, alt, title }: Props) => (
	<Dialog>
		<DialogTrigger asChild className="cursor-pointer">
			{children}
		</DialogTrigger>

		<DialogContent className="max-h-[80%] w-full" showCloseButton={false}>
			<img alt={alt} className="max-h-full max-w-full object-contain" height={500} src={url} width={600} />
			<DialogHeader className="sr-only">
				<DialogTitle>{title || "preview"}</DialogTitle>
				<DialogDescription>{alt}</DialogDescription>
			</DialogHeader>
		</DialogContent>
	</Dialog>
);
